import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import scaleSize from '../../utils/scale-size';
import { Focusable } from '../navigation';
import config from '../../config';

export const PROFILE_ITEM_WIDTH = scaleSize(355);
export const PROFILE_ITEM_MARGIN = scaleSize(20);

const StyledProfileItem = styled(Focusable)`
  width: ${PROFILE_ITEM_WIDTH}px;
  height: ${scaleSize(400)}px;
  display: inline-block;
  text-align: center;
  margin-right: ${PROFILE_ITEM_MARGIN}px;
  margin-bottom: ${scaleSize(150)}px;
  box-sizing: border-box;
  border-radius: ${scaleSize(12)}px;
  background-color: ${({ theme }) => theme.imagePlaceholder};
  transform: translate3d(0, 0, 0);
  transition: ${config.withAnimation ? 'transform 0.2s' : 'none'};
  padding: 0 ${scaleSize(30)}px;
  cursor: pointer;
  white-space: pre-line;

  &:hover {
    transform: translate3d(0, -${scaleSize(10)}px, 0);
  }

  &:focus {
    background-color: ${({ theme }) => theme.activeColor};
    transform: translate3d(0, -${scaleSize(20)}px, 0);

    & > i {
      color: ${({ theme }) => theme.defaultColor};
      border-color: ${({ theme }) => theme.defaultColor};
    }
  }
`;

const ProfileItemTitle = styled.span`
  font-size: ${scaleSize(48)}px;
  line-height: ${scaleSize(48)}px;
  letter-spacing: ${scaleSize(-0.33)}px;
  height: ${scaleSize(34)}px;
  margin-top: ${scaleSize(100)}px;
  margin-bottom: ${scaleSize(5)}px;
  color: ${({ theme }) => theme.defaultColor};
  font-family: RobotoCondensedBold, sans-serif;
  font-weight: bold;
  display: block;
  text-align: center;
`;

const ProfileItemMetadata = styled.i`
  position: relative;
  top: ${scaleSize(110)}px;
  min-width: ${scaleSize(80)}px;
  border-radius: ${scaleSize(4)}px;
  border-style: solid;
  border-width: ${({ hasContent }) => (hasContent ? 0 : `${scaleSize(4)}px`)};
  border-color: ${({ theme, hasContent }) => (hasContent ? 'none' : theme.submenuActiveColor)};
  font-size: ${scaleSize(24)}px;
  line-height: 1.17;
  letter-spacing: ${scaleSize(-0.17)}px;
  color: ${({ theme }) => theme.secondaryTextColor};
  font-style: normal;
  display: inline-block;
  vertical-align: middle;
  font-family: 'RobotoRegular', sans-serif;
  font-weight: 500;
`;

class ProfileItem extends Component {
  onFocus = () => {
    const { onFocus, itemIndex } = this.props;

    onFocus && onFocus(itemIndex);
  };
  onEnter = () => {
    const { onEnter } = this.props;

    onEnter && onEnter();
  };
  render() {
    const { item, focusOnMouseEnter, id } = this.props;
    const hasMetadataContent = item.metadata && item.metadata.length > 0;

    return (
      <StyledProfileItem
        id={id}
        onFocus={this.onFocus}
        onEnter={this.onEnter}
        focusOnMouseEnter={focusOnMouseEnter}
      >
        <ProfileItemTitle>{item.title}</ProfileItemTitle>
        <ProfileItemMetadata hasContent={hasMetadataContent}>{item.metadata}</ProfileItemMetadata>
      </StyledProfileItem>
    );
  }
}

ProfileItem.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string.isRequired,
    metadata: PropTypes.string,
  }).isRequired,
  focusOnMouseEnter: PropTypes.bool,
  itemIndex: PropTypes.number,
  onFocus: PropTypes.func,
  onEnter: PropTypes.func,
};

export default ProfileItem;
